import { useContext } from 'react';
import NavigationContext from '../contexts/NavigationContext';

export default function useNavigationContext() {
  return useContext(NavigationContext);
}
